import React, { useState, useEffect } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import api from '../api';

const sections = [
  { group: 'סקירה', items: [
    { path: '', label: 'דשבורד', icon: 'grid' },
  ]},
  { group: 'SEO', items: [
    { path: '/keywords', label: 'מילים ומיקומים', icon: 'search' },
    { path: '/gsc', label: 'Search Console', icon: 'trending' },
    { path: '/analytics', label: 'Analytics', icon: 'bar-chart' },
    { path: '/competitors', label: 'מתחרים', icon: 'users' },
  ]},
  { group: 'תוכן', items: [
    { path: '/content', label: 'כתיבת תוכן', icon: 'file-text' },
    { path: '/success-stories', label: 'סיפורי הצלחה', icon: 'trophy' },
    { path: '/keyword-research', label: 'מחקר מילים', icon: 'search' },
    { path: '/checklist', label: 'משימות', icon: 'check-square', badge: true },
  ]},
  { group: 'טכני', items: [
    { path: '/health', label: 'סריקה טכנית', icon: 'heart' },
    { path: '/links', label: 'קישורים', icon: 'link' },
  ]},
  { group: 'GEO / AI', items: [
    { path: '/geo', label: 'GEO & AIO', icon: 'globe' },
    { path: '/geo-measurement', label: 'מדידת GEO', icon: 'trending' },
  ]},
  { group: 'ניהול', items: [
    { path: '/reports', label: 'דוחות', icon: 'file' },
    { path: '/paid-ads', label: 'תוצאות עסקיות', icon: 'megaphone' },
    { path: '/workplan', label: 'תוכנית עבודה', icon: 'calendar' },
    { path: '/settings', label: 'הגדרות', icon: 'settings' },
  ]},
];

const icons = {
  grid: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="2" width="7" height="7" rx="1.5"/><rect x="11" y="2" width="7" height="7" rx="1.5"/><rect x="2" y="11" width="7" height="7" rx="1.5"/><rect x="11" y="11" width="7" height="7" rx="1.5"/></svg>,
  search: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="8" r="5.5"/><path d="m13 13 4.5 4.5"/></svg>,
  trending: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 15l4-6 4 3 4-7 4 5"/></svg>,
  'bar-chart': <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="10" width="3" height="8" rx="1"/><rect x="8.5" y="6" width="3" height="12" rx="1"/><rect x="15" y="2" width="3" height="16" rx="1"/></svg>,
  users: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="10" cy="6" r="3"/><circle cx="4" cy="14" r="2.5"/><circle cx="16" cy="14" r="2.5"/></svg>,
  'file-text': <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 4h14M3 8h10M3 12h12M3 16h8"/></svg>,
  'check-square': <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="2" width="16" height="16" rx="2"/><path d="M6 10l2.5 2.5L14 7"/></svg>,
  heart: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M10 18s-7-5.5-7-10.5C3 4 6 2 10 5c4-3 7-1 7 2.5S10 18 10 18z"/></svg>,
  link: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M8.5 11.5a4 4 0 005.5 0l2-2a4 4 0 00-5.5-5.5l-1 1m3 3.5a4 4 0 00-5.5 0l-2 2a4 4 0 005.5 5.5l1-1"/></svg>,
  globe: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M10 2a8 8 0 100 16 8 8 0 000-16zM2 10h16M10 2c2.2 2.5 3.5 5 3.5 8s-1.3 5.5-3.5 8c-2.2-2.5-3.5-5-3.5-8s1.3-5.5 3.5-8z"/></svg>,
  file: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 2h8l4 4v12a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2z"/><path d="M12 2v4h4"/></svg>,
  calendar: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="16" height="14" rx="2"/><path d="M2 7h16M6 1v4M14 1v4"/></svg>,
  trophy: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M6 3h8v4a4 4 0 01-8 0V3z"/><path d="M6 5H3v2a3 3 0 003 3M14 5h3v2a3 3 0 01-3 3"/><path d="M8 13h4v3H8zM7 16h6v2H7z"/></svg>,
  settings: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="10" cy="10" r="3"/><path d="M10 1v2m0 14v2m-7-8H1m18 0h-2M4.2 4.2l1.4 1.4m8.8 8.8l1.4 1.4M4.2 15.8l1.4-1.4m8.8-8.8l1.4-1.4"/></svg>,
  megaphone: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 8v4a1 1 0 001 1h2l2.5 3.5a1 1 0 001.8-.6V4.1a1 1 0 00-1.8-.6L6 7H4a1 1 0 00-1 1z"/><path d="M14 7a4 4 0 010 6"/></svg>,
};

export default function Sidebar() {
  const params = useParams();
  const location = useLocation();
  const [site, setSite] = useState(null);

  // Extract site ID from URL directly since useParams may not work in Layout
  const pathMatch = location.pathname.match(/\/sites\/(\d+)/);
  const siteId = pathMatch ? pathMatch[1] : params.id;

  useEffect(() => {
    if (siteId) api.getSite(siteId).then(setSite).catch(() => {});
  }, [siteId]);

  const [pendingCount, setPendingCount] = useState(0);
  useEffect(() => {
    if (!siteId) return;
    const fetchPending = () => {
      api.getChecklistSummary(siteId)
        .then(data => {
          const pending = (data && data.by_status && data.by_status.pending) || 0;
          setPendingCount(pending);
        })
        .catch(() => {});
    };
    fetchPending();
    const interval = setInterval(fetchPending, 60000);
    return () => clearInterval(interval);
  }, [siteId]);

  const basePath = `/sites/${siteId}`;
  const currentPath = location.pathname.replace(process.env.PUBLIC_URL || '', '');
  const currentSubPath = currentPath.replace(basePath, '') || '';

  return (
    <div className="sidebar">
      <Link to="/" className="sidebar-back">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 12l4-4-4-4"/></svg>
        חזרה לכל האתרים
      </Link>
      <div className="sidebar-header">
        <div className="sidebar-site-name">{site ? site.name : 'טוען...'}</div>
        <div className="sidebar-site-url">
          {site && <a href={site.url} target="_blank" rel="noopener noreferrer">{site.url.replace(/^https?:\/\//, '')} ↗</a>}
        </div>
      </div>
      {sections.map((section) => (
        <div className="sidebar-section" key={section.group}>
          <div className="sidebar-section-title">{section.group}</div>
          {section.items.map((item) => (
            <Link key={item.path} to={`${basePath}${item.path}`}
              className={`sidebar-item ${currentSubPath === item.path ? 'active' : ''}`}>
              {icons[item.icon]}
              {item.label}
              {item.badge && pendingCount > 0 && <span className="sidebar-badge">{pendingCount > 99 ? "99+" : pendingCount}</span>}
            </Link>
          ))}
        </div>
      ))}
    </div>
  );
}
